import moment from 'moment'

/**
 * Generate money format without math
 */
export function moneyFormatFromPositiveInteger(value) {
    if (parseFloat(value) === 0) {
        return '0.00'
    }

    let parts = String(value).split('')
    if (parts.length < 2) {
        for (let i = 0; i < 2 - parts.length; i++) {
            parts.unshift('0')
        }
    }
    parts.splice(-2, 0, '.')
    if (parts[0] == '.') {
        parts.unshift('0')
    }
    return parts.join('')
}

// Slots
export function dateToSlotForSingleDay(dateInstance) {
    const momentInstance = moment(dateInstance)
    // Get the ISO week number (the correct week number according to ISO 8601)
    const weekNum = String(momentInstance.isoWeek()).padStart(2, '0')
    // Get the ISO weekday (Monday is 1, Sunday is 7)
    let dayNum = momentInstance.isoWeekday()
    // Get the year according to ISO standard (which may differ from the calendar year)
    const isoYear = momentInstance.isoWeekYear()
    // Combine all parts into the required string format: yyyywwd
    return [isoYear, weekNum, dayNum].join('')
}

// Money
export function creditsToCents(creditsAmount) {
    return creditsAmount * 10
}

export function centsToCredits(amountCents) {
    return parseInt(amountCents / 10)
}

// Math
export function sum(numberArray) {
    return numberArray.reduce((a, b) => Number(a) + Number(b), 0)
}

// Numbers
export function range(start, end, step = 1) {
    const result = []
    for (let i = start; i < end; i += step) {
        result.push(i)
    }
    return result
}

// Strings
export function randomStringGenerate(stringLength = 20) {
    return (Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2)).substring(0, stringLength)
}

export function joinFiltered(withStr, listToFilter) {
    return listToFilter.filter((item) => !!item).join(withStr)
}

export function snakeCaseToTitleCase(s) {
    return s.replace(/^_*(.)|_+(.)/g, (s, c, d) => (c ? c.toUpperCase() : ' ' + d.toUpperCase()))
}

export function strMaxLength(value, maxLength) {
    if (value.length <= maxLength) {
        return value
    }

    return value.slice(0, maxLength - 1) + '...'
}

export function uuidWeak() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}

// Cookies
export function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
    return match ? decodeURIComponent(match[2]) : null
}

// Date and Time
export function dateFormattedPretty(timeStampOrDateInstance) {
    return moment(timeStampOrDateInstance).format('dddd, MMMM Do')
}

export function dateFormatted(timeStampOrDateInstance) {
    return moment(timeStampOrDateInstance).format('YYYY-MM-DD')
}

export function timeDateFormattedPretty(timeStampOrDateInstance, opts = {}) {
    const format = (opts.short) ? 'ddd, M/D @ h:mma' : 'ddd, MMMM Do @ h:mma'
    return moment(timeStampOrDateInstance).format(format)
}

export function timestampTimeFormattedPretty(timeStampOrDateInstance) {
    return moment(timeStampOrDateInstance).format('h:mm a')
}

export function timestampDayFormattedPretty(timeStampOrDateInstance) {
    return moment(timeStampOrDateInstance).format('dddd, MMMM Do')
}

// Duration
export function formatDuration(ms) {
    const seconds = Math.floor(ms / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)
    const months = Math.floor(days / 30)
    const years = Math.floor(days / 365)

    const remainingDays = days % 365
    const remainingMonths = months % 12
    const remainingHours = hours % 24
    const remainingMinutes = minutes % 60
    const remainingSeconds = seconds % 60

    const parts = []
    if (years > 0) parts.push(`${years}y`)
    if (remainingMonths > 0) parts.push(`${remainingMonths}m`)
    if (remainingDays > 0) parts.push(`${remainingDays}d`)
    if (remainingHours > 0) parts.push(`${remainingHours}h`)
    if (remainingMinutes > 0) parts.push(`${remainingMinutes}m`)
    if (remainingSeconds > 0 || parts.length === 0) parts.push(`${remainingSeconds}s`)

    return parts.join(' ')
}
